import React, { Fragment } from 'react';
import PropTypes from 'prop-types';
import { BuildPriceEntities } from 'client/data/models/build-price';
import { getS3MediaProfileImageUrlBySize } from 'client/utils/image-helpers';
import { getPriceString } from 'site-modules/shared/utils/price-utils';
import { SUBMODEL_IMAGE_SIZE } from 'site-modules/shared/constants/build-price';
import { buildNextLink } from 'site-modules/shared/utils/build-price/build-price';
import { AspectRatioContainer } from 'site-modules/shared/components/aspect-ratio-container/aspect-ratio-container';
import { LinksList } from 'site-modules/build-price/components/links-list/links-list';

export function SubmodelsList({
  buildPriceFilter,
  pathname,
  submodels = null,
  makeSlug,
  modelSlug,
  year,
  modelyearId,
}) {
  if (!submodels) {
    return null;
  }

  const isSingleType = submodels.length === 1;

  const optionsList = submodels.map(({ name, slug, baseMSRP }) => ({
    url: buildNextLink(buildPriceFilter, { modelyearId, submodel: name }, pathname),
    text: (
      <Fragment>
        <AspectRatioContainer aspectRatio="3:2">
          <img
            className="w-100"
            src={getS3MediaProfileImageUrlBySize(
              {
                year,
                make: { slug: makeSlug },
                model: { slug: modelSlug },
                submodels: { slug },
              },
              SUBMODEL_IMAGE_SIZE.PREVIEW.WIDTH,
              SUBMODEL_IMAGE_SIZE.PREVIEW.HEIGHT
            )}
            alt=""
          />
        </AspectRatioContainer>
        <div className="heading-5">{name}</div>
        <div className="small">
          starting at <strong>{getPriceString(baseMSRP)}</strong>
        </div>
      </Fragment>
    ),
    highlighted: isSingleType,
    trackingId: 'build_price_choose_type',
    trackingValue: name,
    dataValue: name,
  }));

  return (
    <Fragment>
      <h2 className="heading-4 mb-1_5">{isSingleType ? 'Available type' : 'Select a type'}</h2>
      <LinksList
        list={optionsList}
        listClassName="row submodels-list text-gray-darker"
        itemClassName="submodel-option col-6 col-md-4 mb-1"
        linkClassName="card px-1 pb-1 h-100"
        keyPrefix="submodel"
      />
    </Fragment>
  );
}

SubmodelsList.propTypes = {
  makeSlug: PropTypes.string.isRequired,
  modelSlug: PropTypes.string.isRequired,
  year: PropTypes.number.isRequired,
  modelyearId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
  pathname: PropTypes.string.isRequired,
  buildPriceFilter: BuildPriceEntities.BuildPriceFilter.isRequired,
  submodels: PropTypes.arrayOf(BuildPriceEntities.Submodel),
};
